/**** polyfills for Chrome Webview < 98 ****/
import "core-js/stable/array/at";
import "core-js/stable/array/find-last";
import "core-js/stable/array/find-last-index";
import "core-js/stable/array/to-reversed";
import "core-js/stable/array/to-sorted";
import "core-js/stable/array/to-spliced";
import "core-js/stable/array/with";
import "core-js/stable/object/has-own";
import "core-js/stable/structured-clone";
/*******************************************/

import "./styles/main.css";
import { registerPlugins } from "./plugins";
import App from "./App.vue";
import { createApp } from "vue";
import "./plugins/dayjs.js";
import "@mdi/font/css/materialdesignicons.css";

const app = createApp(App);

// Nothing awaited before mount: the index.html boot guard only acts while #app is empty and must not see a late failure (ad-blocked vue-matomo).
registerPlugins(app).then(() => app.mount("#app"));
